const checkFeatureToggle = {
  methods: {
    async checkFeatureToggle(tag) {
      try {
        const {data: {status}} = await axios.get(`/api/v2/feature-tester/${tag}`)
        return status
      } catch (error) {
        return false
      }
    }
  }
}

export default checkFeatureToggle;
